import type { ComponentProps } from "react";

const LineChartIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.74321 8.49267C1.94754 8.56601 2.17041 8.45867 2.2428 8.25689L3.27258 5.38599C3.3725 5.1074 3.73336 5.03693 3.93088 5.25685L4.0712 5.41306C4.64653 6.05361 5.69442 5.87607 6.02526 5.07955L6.9152 2.93701C7.02549 2.67148 7.37592 2.61164 7.56776 2.82718L7.8333 3.12556C7.97672 3.28672 8.22362 3.30111 8.38479 3.15769C8.54594 3.01427 8.56034 2.76736 8.41692 2.60621L8.15137 2.30783C7.57745 1.66291 6.52547 1.83859 6.19372 2.63734L5.30377 4.77988C5.19338 5.04566 4.84491 5.10535 4.65243 4.89103L4.51211 4.73482C3.91977 4.07527 2.83698 4.2865 2.53721 5.12222L1.50743 7.99312C1.43457 8.19619 1.54014 8.41984 1.74321 8.49267Z"
        fill={props.fill || "white"}
      />
      <path
        d="M9.60938 9.21875H1.17188C0.956484 9.21875 0.78125 9.04352 0.78125 8.82812V0.390625C0.78125 0.174883 0.606367 0 0.390625 0C0.174883 0 0 0.174883 0 0.390625V8.82812C0 9.4743 0.525703 10 1.17188 10H9.60938C9.82512 10 10 9.82512 10 9.60938C10 9.39363 9.82512 9.21875 9.60938 9.21875Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
};

export default LineChartIcon;
